import styled from 'styled-components'
import { COLORS } from '~/shared/constants/uiConstants'

export const AgeLegalConsentStyles = {
  Text: styled.p`
    margin-top: 16px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: ${COLORS.GRAY_700};

    a {
      color: inherit;
      text-decoration: underline;
    }
  `,
}
